export const mainUrl = 'https://uzoffer.com';
export const baseUrl = 'https://api.uzoffer.com/api';
export const prodBaseUrl = 'https://api.uzoffer.com/api';
export const authUrl = 'https://auth.uzoffer.com/api';

export const Endpoints = {
    authUrl: authUrl,
    sendOTP: authUrl + '/auth/SendVerificationCode',
    verifyOTP: authUrl + '/auth/CheckVerificationCode',
    baseUrl: baseUrl,
    chatUrl: 'https://chat.uzoffer.com',
    photoOriginal: prodBaseUrl + '/image/getimage/original/',
    photoThumb: prodBaseUrl + '/image/getimage/thumb/',
    photoMedium: prodBaseUrl + '/image/getimage/medium/',
    photoProfile: prodBaseUrl + '/image/getimage/profile/',
    photoProfileThumnb: prodBaseUrl + '/image/getimage/profile_thumb/',
    photoProfileBg: prodBaseUrl + '/image/getimage/profile_bg/',
    categories: '/items/GetMainCategories',
    topProduct: '/items/GetTopItems',
    productList: '/items/GetItems',
    subCategories: '/items/GetCategoryTree',
    currencies: '/items/getcurrencies',
    countries: '/items/GetCountries',
    regions: '/items/GetRegions/',
    cities: '/items/GetCities/',
    shippingTypes: '/items/GetShippingType',
    postItem: '/items/PostItem',
    makeOffer: '/Items/MakeOffer',
    itemCondition: '/items/GetItemStatus',
    itemDetails: '/items/GetItemDetails',
    reportItem: '/account/addUserReport',
    getAdsItems: '/adv/GetHomeAdv',
    uploadImages: '/Image/Upload',
    addCard: '/card',
    checkCardNumber: '/Card/CheckCardNumber',
    getUserCards: '/Card/GetUserCard/',
    deleteCard: '/Card',
    setDefaultsCard: '/Card/SetDefaultCard',
    cart: '/Cart/',
    addItemToCart: '/Cart/AddItem',
    getCartCount: '/Cart/',
    updateCartItemQuantity: '/Cart/UpdateQuantity',

    createOrder: '/Order/Checkout',
    checkoutByItem: '/Order/CheckoutByItem',
    getOrder: '/Order/',
    deleteUser: '/Account/DeleteUser',
    setItemToAds: '/Adv/SetItemToAds',
    getAdvPrices: '/Adv/Prices',
    createAdv: '/Adv/Create',
    getUserBanners: '/Adv/GetBannerByUser',
    createBannerOrder: '/Adv/Order',

    // Admin banner moderation
    getHomeBanners: '/Adv/GetHomeBanners',
    approveBanner: '/Adv/Approve',
    rejectBanner: '/Adv/Reject'
};

export const withBaseUrl = (endPoint: keyof typeof Endpoints) => {
    return baseUrl + Endpoints[endPoint];
};
